var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 308,
    viewBox: "0 0 512 308",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M270.826 0H213.666V57.16H270.826V0Z",
    fill: "#1D2136"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.221 78.4517L96.674 221.546L31.951 78.5957H-3V140.001L72.4862 306.729H122.691L192.236 142.353C193.227 140.004 195.001 138.07 197.256 136.88C199.511 135.69 202.109 135.316 204.608 135.823C207.107 136.33 209.354 137.686 210.967 139.661C212.58 141.636 213.46 144.108 213.458 146.657V307.092H270.634V146.263C270.634 143.434 271.758 140.72 273.758 138.72C275.759 136.719 278.472 135.596 281.301 135.596H294.747V197.204L294.838 197.172C297.078 258.247 347.454 307.262 409.062 307.262H512V78.4517H157.221ZM409.062 250.086C397.757 250.086 386.705 246.734 377.305 240.453C367.906 234.172 360.579 225.245 356.253 214.8C351.927 204.356 350.795 192.863 353 181.775C355.206 170.687 360.65 160.502 368.644 152.508C376.638 144.514 386.823 139.07 397.91 136.865C408.998 134.659 420.491 135.791 430.936 140.117C441.381 144.444 450.308 151.77 456.589 161.17C462.869 170.57 466.222 181.621 466.222 192.926C466.201 208.079 460.171 222.604 449.456 233.317C438.741 244.031 424.214 250.057 409.062 250.076V250.086Z",
    fill: "#1D2136"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVia);
export default __webpack_public_path__ + "static/media/via.8da5df622843efef1acf9347d61bbca6.svg";
export { ForwardRef as ReactComponent };